/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DriverReachabilityCheckStatus {
    Placed = 0,
    Connected = 1,
    Voicemail = 2,
    NoAnswer = 3,
    Failed = 4,
}
